<template>
  <div class="page-col">
    <div class="page-main">
      <b-navbar class="p-0" toggleable="lg" :type="isDark ? 'dark' : 'light'" :variant="isDark ? 'dark' : 'light'">
        <b-navbar-brand class="ml-4">
          <strong>Bens do Almoxarifado</strong>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button class="px-2" type="button" :variant="isDark ? 'dark' : 'light'" > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-question-circle"></i></span>
              </b-button>  
              
              <b-button class="px-2" type="reset" :variant="isDark ? 'dark' : 'light'" @click.stop.prevent="limparFiltro()">
                <span style="font-size: 1.2rem" > <i  class="fa fa-ban"></i></span>
              </b-button>                            
              <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarHtml()" title="Imprimir/HTML" v-b-tooltip.hover.bottom> 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-print"></i></span>
              </b-button>
              <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarExcel()" title="Exportar Excel" v-b-tooltip.hover.bottom> 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-file-excel-o"></i></span>
              </b-button>
              <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarCsv()" title="Exportar CSV" v-b-tooltip.hover.bottom> 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-file-text-o"></i></span>
              </b-button>
              <b-button v-if="filtroAvancado === true" class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="filtroAvancado = false" > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-sort-asc"></i></span>
              </b-button>
              <b-button v-else class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="filtroAvancado = true" > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-sort-desc"></i></span>
              </b-button>   
              <b-form-input  type="text" id="edDescricao" ref="edDescricao" placeholder="Informe a descrição (mín. 3 letras)" v-model="descricao" @keydown.enter="pesquisar()"
                                class="px-2" :class="{'bg-gray-100': !isDark, 'bg-dark': isDark, 'text-light': isDark}" style="font-size: 1.2rem"> </b-form-input>
              <b-button class="px-2 font-weight-bold" type="button" :disabled="isBusy"  variant="primary" @click.stop.prevent="pesquisar()" >
                <span style="font-size: 1.2rem" > <b-spinner v-if="isBusy" small ></b-spinner> <i v-else class="fa fa-search"></i></span>
              </b-button>
              
              <div class="border-left pl-2">                              
                <b-button class="px-4 font-weight-bold" ref="btAdicionar" variant="teal" type="button" @click.stop.prevent="novo()" > 
                  <span style="font-size: 1.2rem" >Adicionar <i  class="fa fa-plus-square-o"></i></span>
                </b-button>
              </div>
              
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>


      <b-card  body-class="alert-dark" v-if="filtroAvancado === true">
          <b-row>
            <b-col sm="2">
              <b-form-group>
                <label for="codigo">Código</label>
                <b-form-input type="text" id="codigo" placeholder="Informe o código" v-model="id" @keydown.enter="pesquisar()"></b-form-input>
              </b-form-group>
            </b-col>
            <!--/.col-->
            <b-col sm="3">
              <b-form-group>
                <label for="cpf">Código Barras EAN13</label>
                <b-form-input type="text" id="cpf" placeholder="Cod. barras" v-model="cpf" @keydown.enter="pesquisar()"></b-form-input>
              </b-form-group>
            </b-col>
            <!--/.col-->
            <b-col sm="6">
              <b-form-group>
                <label for="edGrupoProduto">Grupo de Produtos</label>
                <b-form-input type="text" id="edGrupoProduto" placeholder="Informe a Grupo" v-model="grupoId" @keydown.enter="pesquisar()"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
      </b-card>
      


      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="p-0">

            <b-table class="table table-sm mb-2"
                  id="table-transition-example"
                  ref="tbl"
                  :busy.sync="isBusy" 
                  :items="itensFiltrados" 
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="selecionarLinha"
                  @row-dblclicked="edit"
                  :sticky-header="stickyHeight"
                  :tbody-tr-class="rowClassSelecionado"
                  :head-variant="isDark ? 'dark' : 'light'"
                  :dark="isDark"
                  hover 
                  small 
                  bordered 
                  show-empty
                  empty-text="Informe o filtro para ver os registros "
                  responsive 
                    >
                  
              <template #head(CODIGO)>
                <SetFilter
                  label="CODIGO"
                  v-model="filtros.CODIGO"
                  :options="opcoes.CODIGO"
                  :normalizeFn="normalize"
                  dropdown-variant="outline-light"
                />
              </template>
              <template #head(DESCRICAO)>
                <SetFilter
                  label="Descricao"
                  v-model="filtros.DESCRICAO"
                  :options="opcoes.DESCRICAO"
                  :normalizeFn="normalize"
                  dropdown-variant="outline-light"
                />
              </template>
              <template #head(REZUMIDO)>
                <SetFilter
                  label="Resumido"
                  v-model="filtros.REZUMIDO"
                  :options="opcoes.REZUMIDO"
                  :normalizeFn="normalize"
                  dropdown-variant="outline-light"
                />
              </template>
              <template #head(EAN)>
                <SetFilter
                  label="EAN"
                  v-model="filtros.EAN"
                  :options="opcoes.EAN"
                  :normalizeFn="normalize"
                  dropdown-variant="outline-light"
                />
              </template>
              <template #head(NCM)>
                <SetFilter
                  label="NCM"
                  v-model="filtros.NCM"
                  :options="opcoes.NCM"
                  :normalizeFn="normalize"
                  dropdown-variant="outline-light"
                />
              </template>
              <template #head(NOME_GRUPO)>
                <SetFilter
                  label="Grupo"
                  v-model="filtros.NOME_GRUPO"
                  :options="opcoes.NOME_GRUPO"
                  :normalizeFn="normalize"
                  dropdown-variant="outline-light"
                />
              </template>
              <template #head(NOME_SUBGRUPO)>
                <SetFilter
                  label="Sub-grupo"
                  v-model="filtros.NOME_SUBGRUPO"
                  :options="opcoes.NOME_SUBGRUPO"
                  :normalizeFn="normalize"
                  dropdown-variant="outline-light"
                />
              </template>
               <template #head(OP_COFINS_SITUACAO_TRIBUTARIA)>
                <SetFilter
                  label="Cofins"
                  v-model="filtros.OP_COFINS_SITUACAO_TRIBUTARIA"
                  :options="opcoes.OP_COFINS_SITUACAO_TRIBUTARIA"
                  :normalizeFn="normalize"
                  dropdown-variant="outline-light"
                />
              </template>
               <template #head(OP_PIS_SITUACAO_TRIBUTARIA)>
                <SetFilter
                  label="PIS"
                  v-model="filtros.OP_PIS_SITUACAO_TRIBUTARIA"
                  :options="opcoes.OP_PIS_SITUACAO_TRIBUTARIA"
                  :normalizeFn="normalize"
                  dropdown-variant="outline-light"
                />
              </template>
              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>
              
              
              <template #cell(OP_SITUACAO)="item">
                <b-badge pill :variant="colorirOP_SITUACAO(item.item.OP_SITUACAO)" >{{traduzOP_SITUACAO(item.item.OP_SITUACAO)}} </b-badge>
              </template>
              <template #cell(OP_TIPO_BEM)="item">
                {{traduzOP_TIPO_BEM(item.item.OP_TIPO_BEM)}}
              </template>
              <template #cell(OP_USO)="item">
                {{traduzOP_USO(item.item.OP_USO)}}
              </template>
              <template #cell(actions)="item">
                <b-button type="button" @click.stop.prevent="deleteProduto(item.item)" size="sm" variant="danger " >
                  <i class="fa fa-times"></i>
                </b-button>
                <b-button type="button" @click.stop.prevent="copiarProduto(item.item)" size="sm" variant="info " >
                  <i class="fa fa-copy"></i>
                </b-button>
              </template>
            </b-table>
            
        </b-col>
      </b-row>
    </div>  
    <ModalAlertaResultadoGrande
      ref="modalConfirmarResultadoGrande"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
      @shown="modalConfirmacaoAberto = true"
      @hidden="modalConfirmacaoAberto = false"
    />
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import cSwitch from '../../../components/Switch'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import SetFilter from '@/components/Cec/SetFilter.vue'
import Tools from '@/tools/tools.js'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';
import { mapGetters } from 'vuex';

export default {
  components: {
    VueButtonSpinner,
    cSwitch,
    ModalAlertaResultadoGrande,
    SetFilter
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'CODIGO', type: 'number', label: 'ID' },
      { key: 'DESCRICAO', type: 'string', label: 'Descrição' },
      { key: 'REZUMIDO', type: 'string', label: 'Resumido' },
      { key: 'EAN', type: 'string', label: 'EAN' },
      { key: 'NCM', type: 'string', label: 'NCM' },
      { key: 'NOME_GRUPO', type: 'string', label: 'Grupo' },
      { key: 'NOME_SUBGRUPO', type: 'string', label: 'Sub-Grupo' },
      { key: 'NOME_TIPO', type: 'string', label: 'Tipo' },
      { key: 'OP_COFINS_SITUACAO_TRIBUTARIA', type: 'string', label: 'COFINS' },
      { key: 'OP_pis_SITUACAO_TRIBUTARIA', type: 'string', label: 'PIS' }
    ]
  })],

  data () {
    return {
      

      isLoading: false,
      status: '',
      isBusy: false,
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      filtros: { CODIGO: [], DESCRICAO: [], REZUMIDO: [] },
      filtrosConfig: {
        DESCRICAO: { key: 'DESCRICAO', op: 'in' },
        CODIGO: { key: 'CODIGO', op: 'in' },
        REZUMIDO: { key: 'REZUMIDO', op: 'in' }
      },
      
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      fields: [
        {
          key: "CODIGO",
          label: 'CODIGO',
          class:'align-middle text-right',
          thStyle: { width: "5%" },
          sortable: true
        },
        {
          key: "OP_SITUACAO",
          label: 'Situação', 
          class:'align-middle',
          thStyle: { width: "5%" },
          sortable: true 
        },,
        {
          key: "DESCRICAO",
          label: 'Descrição', 
          class:'align-middle',
          thStyle: { width: "15%" },
          sortable: true 
        },
        {
          key: "REZUMIDO",
          label: 'Resumido', 
          class:'align-middle',
          thStyle: { width: "10%" },
          sortable: true 
        },
        {
          key: "CODIGO FABRICANTE",
          label: 'Cod. Fabricante', 
          class:'align-middle',
          thStyle: { width: "10%" },
          sortable: true 
        },
        {
          key: "OP_TIPO_BEM",
          label: 'Tipo Bem', 
          class:'align-middle',
          thStyle: { width: "10%" },
          sortable: true 
        },
        {
          key: "OP_USO",
          label: 'Uso', 
          class:'align-middle',
          thStyle: { width: "10%" },
          sortable: true 
        },
        {
          key: "NOME_GRUPO",
          label: 'Grupo', 
          class:'align-middle',
          thStyle: { width: "20%" },
          sortable: true 
        },
         {
          key: "NOME_SUBGRUPO",
          label: 'Sub-Grupo', 
          class:'align-middle',
          thStyle: { width: "10%" },
          sortable: true 
        },
        {
          key: "actions" ,
          thStyle: { width: "5%" },
          class:'align-middle p-0 text-right',
          label: 'Ações' 
        }
      ]

    }
  },
  
  
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },

    // Cada tabela constrói sua própria rowFilter a partir da sua config
    rowFilterListagem() { 
      return this.buildRowFilter(this.filtrosConfig) 
    },
    currentPage: {
      get () {
        return this.$store.getters['bens/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("bens/SET_PAGINA_ATUAL", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['produto/PER_PAGE']
      }, 
      set (value) {
        this.$store.commit("produto/SET_PER_PAGE", value);
      }
    },
    filtroAvancado: {
      get () {
        return this.$store.getters['bens/FILTRO_AVANCADO']
      }, 
      set (value) {
        this.$store.commit("bens/SET_FILTRO_AVANCADO", value);
      }
    },
    filtroCabecalho: {
      get () {
        return this.$store.getters['bens/FILTRO_CABECALHO']
      }, 
      set (value) {
        this.$store.commit("bens/SET_FILTRO_CABECALHO", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['bens/ID']
      }, 
      set (value) {
        this.$store.commit("bens/SET_ID", value);
      }
    },
    descricao: {
      get () {
        return this.$store.getters['bens/DESCRICAO']
      }, 
      set (value) {
        this.$store.commit("bens/SET_DESCRICAO", value);
      }
    },
    ean: {
      get () {
        return this.$store.getters['bens/EAN']
      }, 
      set (value) {
        this.$store.commit("bens/SET_EAN", value);
      }
    },
    grupoId: {
      get () {
        return this.$store.getters['bens/GRUPO_ID']
      }, 
      set (value) {
        this.$store.commit("bens/SET_GRUPO_ID", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['bens/LISTA']
      }, 
      set (value) {
        this.$store.commit("bens/SET_LISTA", value);
      }
    }
  },
  methods: {


    limparFiltros() {
      this.teste.filtros = { nome: '', cidade: '', status: '' }
    },
    async deleteProduto() {
      this.$bvModal.msgBoxOk('Operação não permitida', {
          title: 'Remover',
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
      
    },
    
    async copiarProduto(item) {
      const msg = await this.$bvModal.msgBoxConfirm(`Copiar o Produto: ${item.DESCRICAO} ?`, {
          title: 'Copiar',
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'success',
          okTitle: 'SIM',
          cancelTitle: 'NÃO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          noCloseOnEsc: true, 
          noCloseOnBackdrop: true
        })
        
        if (msg == false) return   

        try {
          this.$store.commit('controle/setAguardando', true)
          
          const {data} = await this.$http.post(`/api/protected/produto/copiar`, {id: item.CODIGO})

          if (!data || !data.id) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel copiar!')
            return
          }

          this.$store.commit("bens/SET_LIMPAR", null)
          this.$store.commit("bens/SET_REGISTRO_SELECIONADO_ID", data.id)
          this.$store.commit("bens/SET_ID", data.id)
          this.$store.commit('bens/SET_PAGINA_ATUAL', 1)
          await this.$store.dispatch('bens/GET_LISTA')
          this.$store.commit("bens/SET_LIMPAR_APENAS_FILTRO", null) // limpar o filtro pq ja localizou o registro novo 
          
          this.$router.push(`/almoxarifado/bens/edit/${data.id}`)

        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel copiar!')
          return
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
    },

  /*************************************************************************** */
    clicarLinha(item) {
      this.$store.commit("bens/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['bens/REGISTRO_SELECIONADO_ID']
      return item.CODIGO === selId ? 'cec-row-selected' : ''
    },
    colorirOP_SITUACAO(item) { 
      return item === '1' ? 'success' : 'danger'
    },

    traduzOP_SITUACAO(item) {
      return item === '1' ? 'Ativo' : 'Inativo'
    },
    retirarFormatacao(campoTexto) {
      // Verifica se campoTexto é nulo ou undefined
      if   ((!campoTexto) 
        || (!(campoTexto instanceof HTMLElement)) 
        || (!campoTexto.hasOwnProperty('value')) 
        || (typeof campoTexto.value !== 'string')) {
        return
      }

      // Remove formatação
      campoTexto.value = campoTexto.value.replace(/(\.|\/|\-)/g, "");
    },
    traduzOP_TIPO_BEM(valor) {
      switch (valor) {
        case '0':
          return 'CI - Consumo Interno'
        case '1':
          return 'IP - Imobilizado Principal'
        case '2':
          return 'IM - Ativo Imobilizado'
        case '3':
          return 'TD - Todos os Produtos'    
        case '4':
          return 'VE - Veículo'      
        default:
          return ''
      }
    },
    traduzOP_USO(valor) {
      switch (valor) {
        case '0':
          return 'Administrativo'
        case 'X':
          return 'Almoxarifado'
        case 'I':
          return 'Industrial'
        case 'O':
          return 'Outros'
        case '':
          return ''
        default:
          return ''
      }
    },

    limparFiltro() {
      this.$store.commit("bens/SET_LIMPAR", null);
    },
    details (item) {
      alert(JSON.stringify(item.CODIGO))
    },
    edit (item) {
      this.$store.commit("bens/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
      this.$router.push(`/almoxarifado/bens/edit/${item.CODIGO}`)
    },
    novo () {
      this.$router.push(`/almoxarifado/bens/add`)
    },
    async pesquisar () {
      if (this.modalConfirmacaoAberto) {
        return;
      }
      this.$store.commit('controle/setAguardando', true)
      try {
        const result = await this.$store.dispatch('bens/GET_LISTA')
        
        if (result.needsConfirmation) {
          this.resultadoPendenteCount = result.count
          this.$refs.modalConfirmarResultadoGrande.show()
          this.$store.commit('controle/setAguardando', false)
          return
        }
        
        this.$store.commit('controle/setAguardando', false)
      } catch (err) {
        this.$store.commit('controle/setAguardando', false)
        this.lista = []
        this.toastCount++

        let msg 
        if (err.response && err.response.status) {
          msg = err.response.data
          this.$root.$bvToast.toast(msg, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        } else {
          this.$root.$bvToast.toast(`Falha ao pesquisar !! ${err}`, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
        }
      }

    },
    async confirmarCarregarResultadoGrande() {
      this.$store.commit('controle/setAguardando', true)
      try {
        await this.$store.dispatch('bens/GET_LISTA', { skipConfirmation: true })
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      } catch (error) {
        this.$root.$bvToast.toast(`Falha ao carregar os registros: ${error.message}`, {
          title: 'Falha',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      this.$root.$bvToast.toast('Carregamento de resultado grande cancelado', {
        title: 'Informação',
        autoHideDelay: 5000,
        variant: 'info',
        appendToast: true
      })
    },
    exportarHtml () {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.fields,
        systemName: 'CECWeb',
        reportTitle: 'Listagem de Bens',
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: `Filtro: ${this.descricao || 'todos'}`,
        pageSize: 'A4',
        landscape: true,
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'bens.xls'
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'bens.csv',
      });
    },
    handleKeydown(event) {
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.novo()
      } else if (event.key === "Enter") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.pesquisar()
      } 
    }
  },
  mounted () {
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
    }, 200)
    this.$nextTick(() => {
      this.$refs.edDescricao?.focus()
    })
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown)
  },
}
</script>
<style >
/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky 
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}
  */

/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6 !important;
  color: #000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6 !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #adbac3 !important;
}


</style>




// WEBPACK FOOTER //
// src/views/almoxarifado/bens/BensListagem.vue